<template>
  <span class="text spacex-4">
    <Badge
      v-if="!tender.offers_with_submitted_version_count"
      color="light-blue"
      contrast
      class="tender-status"
    >
      {{ $t('New') }}
    </Badge>
    <Badge v-else color="light-green" contrast class="tender-status">
      {{ $tc('offer', tender.offers_with_submitted_version_count) }}
    </Badge>
  </span>
</template>

<script>
  import Badge from '@/components/ui/Badge';

  export default {
    name: 'TenderCardOffersBadge',
    components: {
      Badge,
    },
    props: {
      tender: {
        type: Object,
        required: true,
      },
    },
  };
</script>
